import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Loading } from '../components/Loading';
import { TaxonomyController } from '../controllers/TaxonomyController';
import { useCountryMarketConfigs } from '../hooks/queries';
import { useAuth } from '../hooks/useAuth';

const AuthLayout = () => {
  const [{ auth }] = useAuth();
  const availableCountryMarketConfigs = useCountryMarketConfigs();
  const location = useLocation();

  if (auth.isLoaded) {
    if (!auth.isEmpty) {
      return (
        <TaxonomyController>
          <Outlet />
        </TaxonomyController>
      );
    } else {
      if (availableCountryMarketConfigs) {
        return <Navigate to="/" state={{ from: location }} replace />;
      } else {
        return (
          <div className="flex items-center justify-center w-full h-300px">
            <Loading />
          </div>
        );
      }
    }
  } else {
    return (
      <div className="flex items-center justify-center w-full h-300px">
        <Loading />
      </div>
    );
  }
};

export default AuthLayout;
